(() => {
  const ready = () => {
    document.querySelectorAll('[data-zonez-menu-toggle]').forEach((toggle) => {
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!menu) return;
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        menu.toggleAttribute('data-open', !open);
      });
    });

    document.querySelectorAll('[data-zonez-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-zonez-gallery-main]');
      const thumbs = [...gallery.querySelectorAll('[data-zonez-gallery-thumb]')];
      if (!main || !thumbs.length) return;
      const activate = (thumb) => {
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        thumbs.forEach((item) => item.setAttribute('aria-current', item === thumb ? 'true' : 'false'));
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => activate(thumb)));
    });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ready) : ready();
})();
